const handles = {
    'linkedin': 'www.linkedin.com/company/sciative-solutions-private-limited/mycompany/',
    'facebook': 'www.facebook.com/profile.php?id=100085304680567',
    'instagram': 'www.instagram.com/sciative_solutions/?igsh=ZzF0c2tiMGtqYTFq',
    'x': 'www.twitter.com/Sciative',
    'youtube': 'www.youtube.com/@sciativesolutions/videos',
    'spotify': 'open.spotify.com/show/0WYi6GHuWFEFvrE4dFol3Z'
}

export default handles;